import { render, staticRenderFns } from "./DoubleLeftAroow.vue?vue&type=template&id=2ab43162&scoped=true&"
var script = {}
import style0 from "./DoubleLeftAroow.vue?vue&type=style&index=0&id=2ab43162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab43162",
  null
  
)

export default component.exports